export const COMPARABLES_LAYER_TYPE_ID = "COMPARABLES_LAYER_TYPE_ID";
export const COMPARABLES_LAYER_SUMMARY_TYPE_ID = "COMPARABLES_LAYER_SUMMARY_TYPE_ID";
export const HOMETRACK_LAYER_SUMMARY_TYPE_ID = "HOMETRACK_LAYER_SUMMARY_TYPE_ID";
